<div class="lc-route-outlet">
  <router-outlet></router-outlet>
</div>